import React from "react";
import { useEffect, useState } from "react";
import { Header } from "../../../components/common/Header.js";
import { SideBar } from "../../../features/SideBar/SideBar.js";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//API
import { getDetail } from "../DetailSlice.js";
import { getSeasonDetail } from "../DetailSlice.js";
//Child Comp
import { InfoShowcase } from "../../../features/MovieShowcase/InfoShowcase.js";
import { SeasonShowcase } from "../../../features/TvShowcase/SeasonShowcase.js";
import Breadcrumb from "../../../components/common/BreadCrumb.js";
//Style
import "../DetailsPage.css";

export const SeasonDetailPage = (props) => {
  const { tvId, seasonId } = useParams();

  //Get Config
  let apiUtility = useSelector((state) => state.apiUtility.apiUtility);
  let { langConfig, tvGenreList } = apiUtility;

  //Handle API Call
  const dispatch = useDispatch();
  let detailDataList = useSelector((state) => state.detail);

  let [tvDetailData, setTvDetailData] = useState(null);
  //Get TV Data
  useEffect(() => {
    if (!detailDataList.detailList["tvList"][tvId]) {
      if (tvDetailData) {
        setTvDetailData(null); //MidAutumn
      }
      dispatch(getDetail({ id: tvId, type: "tv" })).then((res) =>
        setTvDetailData(res.payload)
      );
    } else {
      setTvDetailData(detailDataList.detailList.tvList[tvId]);
    }
  }, [tvId]);

  let [seasonData, setSeasonData] = useState(null);

  //Update Season Data
  useEffect(() => {
    if (detailDataList.detailList["tvList"][tvId]) {
      let targetSeason = detailDataList.detailList.tvList[tvId].seasons.filter(
        (item) => item.season_number == seasonId
      )[0];
      setSeasonData(targetSeason);
    }
  }, [seasonId, detailDataList]);

  //Get Season Details Data
  useEffect(() => {
    if (seasonData && seasonData.seasonDetail.seasonLoading == true) {
      dispatch(
        getSeasonDetail({
          tvId: tvId,
          seasonNumber: seasonData.season_number,
        })
      );
    }
  }, [seasonData]);

  //Custom InfoShowcase Props
  function customInfoShowCase(tvProps, seasonProps) {
    let finalInfo = { ...tvProps };
    finalInfo.title = seasonProps.name;
    finalInfo.poster_path = seasonProps.poster_path;
    finalInfo.overview = seasonProps.overview;
    finalInfo.release_date = seasonProps.air_date;
    finalInfo.country = null;
    finalInfo.runtime = null;
    finalInfo.credits = {};
    finalInfo.credits.cast = seasonProps.credits.cast ;
    finalInfo.others = {};
    finalInfo.others["Episodes"] = seasonProps.episodes ? seasonProps.episodes.length : seasonProps.episode_count;
    return finalInfo;
  }

  //Custom BreadCrumb Tabs
  const styleBreadCrumb = {
    marginLeft: "calc(400vw/30)",
    marginRight: "calc(200vw/30)",
  };

  function customPathBreadCrumb(tvProps, seasonProps) {
    let tvName = tvProps.title;
    let seasonName = seasonProps.name;

    return [
      { label: tvName, url: `/details/tv/${tvId}` },
      { label: seasonName, url: `/details/tv/${tvId}/${seasonId}` }
    ];
  }

  return (
    <>
      <div className="detail-page">
        <Header />
        {seasonData == null ||
        !seasonData.seasonDetail ||
        seasonData.seasonDetail.seasonLoading ? (
          <h3>Loading...</h3>
        ) : detailDataList.detailListError ? (
          <h3>Error 404</h3>
        ) : (
          <div className="mov_details_page_content_wrapper">
            <div className="ep_page_info_wrapper">
              <div
                className="ep_page breadcrumb_wrapper"
                style={styleBreadCrumb}
              >
                <Breadcrumb
                  paths={customPathBreadCrumb(
                    detailDataList.detailList.tvList[tvId],
                    seasonData.seasonDetail.seasonInfo,
                  )}
                />
              </div>
              <InfoShowcase
                detailData={customInfoShowCase(
                  detailDataList.detailList.tvList[tvId],
                  seasonData.seasonDetail.seasonInfo,
                )}
              />
            </div>

            <div className="ep_page_season_showcase_wrapper">
              <SeasonShowcase
                detailData={tvDetailData.seasons}
                tvId={tvId}
                title={tvDetailData.title}
              />
            </div>
          </div>
        )}
      </div>
      <SideBar />
    </>
  );
};
